import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import moment from 'moment'
import type { TFunction } from 'react-i18next'
import { Input } from '../../../components'
import type { TicketSize } from '../../../types'
import type { ExtendedTicketSize } from './TicketSizes'

interface TableDisplayParams {
    onSelectTicketSize: (id: number, isSelected: boolean) => void;
    t: TFunction;
}

const tableDisplay = ({ onSelectTicketSize, t }: TableDisplayParams) => {
    const elements = [
        {
            onlyOnMobile: true,
            field: 'size',
            label: t('ticket-size-size'),
            props: { style: { textAlign: 'left' } },
            transform: null,
            width: '200px',
        },
        {
            onlyOnMobile: true,
            field: null,
            label: '',
            props: { align: 'center' },
            transform: ({ id, selected = false }: ExtendedTicketSize) => (
                <Input
                    onChange={(e: React.MouseEvent) => {
                        e.stopPropagation()
                        onSelectTicketSize(id, !selected)
                    }}
                    type="check"
                    value={selected}
                />
            ),
            width: '50px',
        },
        {
            onlyOnMobile: true,
            field: 'start_date',
            label: t('ticket-size-start-date'),
            props: { paddingLeft: '15px', textAlign: 'left' },
            transform: (dateStart: string) => (
                <>{moment(dateStart).format('DD/MM/YYYY')}</>
            ),
            width: '100px',
        },
        {
            field: null,
            label: '',
            props: null,
            transform: () => (
                <FontAwesomeIcon icon="chevron-right" />
            ),
            width: '20px',
        },
        {
            field: 'size',
            label: t('ticket-size-size'),
            props: null,
            transform: null,
            width: '200px',
        },
        {
            field: null,
            label: '',
            props: { align: 'center' },
            transform: ({ id, selected = false }: ExtendedTicketSize) => (
                <Input
                    onChange={(e: React.MouseEvent) => {
                        e.stopPropagation()
                        onSelectTicketSize(id, !selected)
                    }}
                    type="check"
                    value={selected}
                />
            ),
            width: '50px',
        },
        {
            field: 'start_date',
            label: t('ticket-size-start-date'),
            props: { paddingLeft: '15px' },
            transform: (dateStart: string) => (
                <>{moment(dateStart).format('DD/MM/YYYY')}</>
            ),
            width: '120px',
        },
        {
            field: 'end_date',
            label: t('ticket-size-end-date'),
            props: null,
            transform: (dateEnd: string) => (
                <>{moment(dateEnd).format('DD/MM/YYYY')}</>
            ),
            width: '120px',
        },
        {
            field: 'skus',
            label: t('ticket-size-skus'),
            props: { align: 'center' },
            transform: (skus: TicketSize['skus']) => (
                <>{skus.length}</>
            ),
            width: '80px',
        },
        {
            field: 'storecodes',
            label: t('ticket-size-storecodes'),
            props: { align: 'center' },
            transform: (storecodes: TicketSize['storecodes']) => (
                <>{storecodes.length === 0 ? t('ticket-size-all-storecodes') : storecodes.length}</>
            ),
            width: '110px',
        },
    ]

    return elements
}

export default tableDisplay
